import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title:
    "Hur mycket skulle en cyberattack kosta ditt företag? Ta reda på det på 20 sekunder.",
  header:
    "Hur mycket skulle en cyberattack kosta ditt företag? Ta reda på det på 20 sekunder.",
  date: "2025-11-13",
  description:
    "Varför cyberrisk är ett affärsproblem – och hur vår kostnadsfria analys på 20 sekunder gör luddig risk till tydliga siffror och åtgärder.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
